import * as React from "react";
const SvgFiRrPepper = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pepper_svg__a)">
      <path
        fill="#062147"
        d="M21.945 6.479a6 6 0 0 0-2.98-1.392C18.619.687 15.752 0 13.999 0a1 1 0 0 0 0 2c1.172 0 2.687.351 2.955 3.105A6.07 6.07 0 0 0 12 11.048C11.98 13.338 10.516 15 8.516 15c-.592 0-2.392 0-3.3-3.936A2.63 2.63 0 0 0 2.649 9c-5.314.483-1.614 9.518.945 11.563A12.44 12.44 0 0 0 12.224 24 12.247 12.247 0 0 0 24 11.635a6.2 6.2 0 0 0-2.055-5.156m-4.512.56a3.95 3.95 0 0 1 2.933.762 2.957 2.957 0 0 1-4.733 0 3.8 3.8 0 0 1 1.8-.762M22 11.635c-.5 13.831-19.867 13.638-19.992-.014a.639.639 0 0 1 1.26-.109C4.313 16.048 6.7 17 8.516 17c3.1 0 5.457-2.552 5.484-5.937a4.2 4.2 0 0 1 .371-1.657 4.966 4.966 0 0 0 7.283-.028c.292.714.41 1.488.347 2.257"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pepper_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPepper;
